import React ,{Fragment} from "react";
import styles from "./Template.module.css";
const Template = (props) => {
  return (
    <Fragment>
      <div className={styles.templateContainer}>
        <div className={styles.topPannel} > {props.children[0]}</div>
        <div className={styles.leftSidePannel}> {props.children[1]} </div>
        <div className={styles.middlePannel}> {props.children[2]} </div>
        <div className={styles.rightSidePannel}>  {props.children[3]}</div>
      </div>
    </Fragment>
  );
};

export default Template;
